import * as Yup from 'yup';
import { emailSchema, mainUserFormSchema } from '../../userFormValidations';

const conclusionSchema = Yup.object().shape(
  {
    email: Yup.reach(emailSchema, 'email'),
    emailConfirmation: Yup.reach(emailSchema, 'emailConfirm'),
    cellPhone: Yup.reach(mainUserFormSchema, 'cellPhone'),
    phone: Yup.reach(mainUserFormSchema, 'phone'),
    receivedCompensationSum: Yup.number()
      .nullable()
      .typeError('validationErrors.onlyNumber')
      .max(200000000, 'validationErrors.maxNumber')
      .when('receivedCompensation', (receivedCompensation, schema) => {
        if (receivedCompensation === 'received') {
          return schema
            .test('isZero', 'validationErrors.isRequired', (v) => v !== 0)
            .required('validationErrors.isRequired');
        }
        return schema;
      }),
    hasAgreed: Yup.boolean().test(
      'hasAgreed',
      'validationErrors.isRequired',
      (value) => !!value,
    ),
  },
  [['cellPhone', 'phone']],
);

export default conclusionSchema;
